import axios from "axios";
const appUrl = window.TLKAbbonamentoptions.ajaxurl;
export const getData = {
    methods: {
        getTestData(form_id, entry_id, obiettivi_id, allergeni_id) {
            let data = new FormData();
            data.append('action', 'tlk_test_data');
            data.append('form_id', form_id);
            data.append('entry_id', entry_id);
            data.append('obiettivi_id', obiettivi_id);
            data.append('allergeni_id', allergeni_id);
            return axios.post(`${appUrl}`,data);
        },
        getUserData() {
            let data = new FormData();
            data.append('action', 'tlk_user_data');
            return axios.post(`${appUrl}`,data);
        },
        getSubscriptions() {
            let data = new FormData();
            data.append('action', 'tlk_abbonamento_subscriptions');
            return axios.post(`${appUrl}`,data);
        },
        getObiettivi() {
            let data = new FormData();
            data.append('action', 'tlk_abbonamento_obiettivi');
            return axios.post(`${appUrl}`,data);
        },
        getAllergeni() {
            let data = new FormData();
            data.append('action', 'tlk_abbonamento_allergeni');
            return axios.post(`${appUrl}`,data);
        },
        getProducts(obiettivi, allergeni, ndays=5) {
            let data = new FormData();
            data.append('action', 'tlk_abbonamento_products');
            data.append('obiettivi', obiettivi);
            data.append('allergeni', allergeni);
            data.append('ndays', ndays);
            return axios.post(`${appUrl}`,data);
        },
        addToCart(abbonamento){
            let data = new FormData();
            const json = JSON.stringify(abbonamento);
            data.append('action', 'tlk_abbonamento_addtocart');
            data.append('abbonamento', json);
            return axios.post(`${appUrl}`,data);
        },
        updateAbbonamento(abbonamento){
            let data = new FormData();
            const json = JSON.stringify(abbonamento);
            data.append('action', 'tlk_abbonamento_update');
            data.append('abbonamento', json);
            return axios.post(`${appUrl}`,data);
        }
    }
};